import { render, staticRenderFns } from "./CollapseHover.vue?vue&type=template&id=25e90b5c&"
import script from "./CollapseHover.vue?vue&type=script&lang=js&"
export * from "./CollapseHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports